import styled from "styled-components";

export const AboutUs = styled.aside`
    .aboutUs {
        margin-top: 30px;
}

    .aboutUs h2 {
        text-align: center;
        margin-bottom: 20px;
    }

    .aboutUs p {
        display: block;
        width: 90%;
        margin: auto;
        text-align: center;

}
`